import { Printer } from '@ionic-native/printer';

// ... inside your component or function
async function printIonicContent(content) {
    try {
        await Printer.print(content); // Or pass a URL/HTML string
        console.log('Print job initiated');
    } catch (error) {
        console.error('Error printing:', error);
    }
}

export default printIonicContent